module.exports = __webpack_public_path__ + "static/media/weather-1.c13b98f5.png";